export default __webpack_public_path__ + "static/media/dashboard_es.71db1312.png";